export function getGrowthStatementByCategory(category: string | null): string {
  switch (category) {
    case "MUCH_FASTER":
      return "Much faster than the average";
    case "FASTER":
      return "Faster than the average";
    case "AVERAGE":
      return "As fast as the average";
    case "SLOWER":
      return "Slower than the average";
    case "NO_CHANGE":
      return "Little or no change";
    case "DECLINE":
      return "Decline";
    default:
      return "Data not available";
  }
}
